import { Component, Input, OnInit } from '@angular/core';
import { BooleanToYesNoPipe } from 'src/app/shared/utils/boolean-to-yes-no.pipe';

@Component({
  selector: 'app-assessment-info',
  templateUrl: './assessment-info.component.html',
  styleUrls: ['./assessment-info.component.scss'],
  standalone: true,
})
export class AssessmentInfoComponent<T> implements OnInit {
  @Input() data!: T;

  constructor() { }

  ngOnInit(): void { }
}
